<template>
    <rkm-table
        :busy="busy"
        :fields="fields.datatables.classificacaoRisco"
        :items="items"
        ref="RkmTable"
    >
        <template v-slot:cell(cor)="{ item }">
            <div
                :style="{
                    'background': 'currentColor',
                    'border': '1px solid rgba(0,0,0,0.15)',
                    'border-radius': '50%',
                    'box-shadow': '2px 2px 6px -2px currentColor',
                    'color': item.tipo.cor,
                    'height': '18px',
                    'width': '18px',
                }"
            ></div>
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'pronto-atendimento-classificacao-risco-edit', params: { id: item.id } })"
                authorize="update-pronto-atendimento-classificacao-risco"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                authorize="destroy-pronto-atendimento-classificacao-risco"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                datatables: {
                    classificacaoRisco: [
                        {
                            key: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'tipo.nome',
                            label: 'Tipo',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'cor',
                            label: 'Cor',
                        },
                        {
                            class: 'col-min',
                            key: 'actions',
                            label: 'Ações',
                        },
                    ]
                }
            }
        },
    },
    created() {
        this.repositories = {
            classificacaoRisco: this.getConectaSusRepository('prontoAtendimento.classificacaoRisco')
        }
    },
    data: () => ({
        busy: false,
        items: [],
    }),
    methods: {
        load() {
            this.busy = true

            this.repositories.classificacaoRisco.index()
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.busy = false)
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.classificacaoRisco.destroy(id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a classificação de risco?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
    mounted() {
        this.load()
    },
}
</script>